import React from 'react';
import styled from 'styled-components';
import { StaticImage } from 'gatsby-plugin-image';

const CardWrap = styled.div`
	padding: 40px 30px 25px;
  border: 1px solid #D0D0D0;
  border-radius: 6px;
  background: white;
  box-shadow: 0 5px 10px rgba(0, 0, 0, .1);
  margin-bottom: 72px;

  .title {
    font-size: 26px;
    font-family: "Eina03-Bold";
    line-height: 24px;
    margin: 20px 0;
  }

  .gatsby-image-wrapper {
    width: 100%;
  }
  p {
  	font-size: 16px;
  	line-height: 24px;
  	margin-bottom: 15px;
  }
  span{
    display: block;
    font-size: 12px;
    line-height: 20px;
    text-align: center;
    color:#666;
  }
`

const PanelCard = () => {
  return (
    <CardWrap>
      <StaticImage
        src="../../images/panel-warranty.png"
        placeholder="blurred"
        formats={["AUTO", "WEBP", "AVIF"]}
        alt="limited warranty"
      />
      <h3 className="title">Guarantee of Excellence</h3>
      <p>Only Buildings and More can offer this amazing warranty.</p>
      <p>All Buildings and More buildings are engineered from top quality materials chosen for strength and durability. Each building is protected against termites, vermin, rain, and moisture.</p>
      <p>Buildings are warrantied for up to 36 months on materials and workmanship against defects, 40 years on treated.</p>
      <span>*Warranties may vary depending on manufacturer and geographical location.</span>
    </CardWrap>
  )
}

export default PanelCard;